export const ChevronUpIcon = ({ color }) => {
  return (
    <path
      d="M12 10.4538L7.92701 14.527C7.78851 14.6653 7.61443 14.7362 7.40476 14.7395C7.19526 14.7427 7.01801 14.6718 6.87301 14.527C6.72818 14.382 6.65576 14.2063 6.65576 14C6.65576 13.7937 6.72818 13.618 6.87301 13.473L11.3673 8.97876C11.5481 8.7981 11.759 8.70776 12 8.70776C12.241 8.70776 12.4519 8.7981 12.6328 8.97876L17.127 13.473C17.2653 13.6115 17.3362 13.7856 17.3395 13.9953C17.3427 14.2048 17.2718 14.382 17.127 14.527C16.982 14.6718 16.8063 14.7443 16.6 14.7443C16.3937 14.7443 16.218 14.6718 16.073 14.527L12 10.4538Z"
      fill={color}
    />
  )
}
